import React from "react";

// Style \\
import "../../assets/styles/card/teamCard.scss";

// Data \\
import peson from "../../assets/images/person.jpg";

const TeamCards = (props) => {
  const data = props.data;
  console.log(data.name);
  return (
    <div className="teamCard_box">
      <article class="card" id={data.id}>
        <img
          class="card__background"
          src={peson}
          alt="Photo of Cartagena's cathedral at the background and some colonial style houses"
          width="1920"
          height="2193"
        />
        <div class="card__content | flow">
          <div class="card__content--container | flow">
            <h2 class="card__title">{data.name}</h2>
            <p class="card__description ">{data.desc}</p>
          </div>
          {/* <button class="card__button">Read more</button> */}
        </div>
      </article>
    </div>
  );
};

export default TeamCards;
